import { IOYButtonProps } from './../OYButton/const';
/* eslint-disable max-nested-callbacks */
import { IOYTab } from '../OYTab/const';
import styles from './index.module.less';
import template from './index.art';
import selectedTagTemplate from './selectedTag.art';
import { jeact } from '../../decorators/jeact';
import { EEventType } from '../../enums/EEventType';
import { valueIncludes } from '../../utils';
import { ECheckType, ILetterMap, IOYCategoryTabProps, IOYCategoryTabState, IOYCategoryTabInfoInfo } from './const';
import OY from '../../types/OY';
import OYTab from '../OYTab';
import { ECheckMode } from '../../enums/ECheckMode';
import OYButton from '../OYButton';

const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

@jeact({ autoRender: true })
export default class OYCategoryTab extends OY<IOYCategoryTabProps, IOYCategoryTabState> {
  static displayName = 'OYCategoryTab';

  static defaultProps: Partial<IOYCategoryTabProps> = {
    flatSearch: false,
    display: 'text',
    cateBtnText: '按加工用途分类',
    value: [],
    info: [],
    // cells: 6,
    maxTextLength: 15
  }

  public state: IOYCategoryTabState = {
    expand: false,
    check: false,
    checkboxOption: {
      box: false,
      mode: ECheckMode.Radio
    },
    tags: [],
    checkType: ECheckType.Category,

    curretTabKey: '',
    letterTabKey: '',
    tabs: [],
    width: '',
    titleWidth: '',
    contentWidth: '',
    letterMap: [],
    flatData: [],
    inputValue: ''
  };

  public $el: JQuery = $();

  $node = {
    flatData: $()
    // checkTabPaneContent: $()
  }

  oyTab: OYTab | null = null;

  getDerivedStateFromProps(nextProps: IOYCategoryTabProps, state: IOYCategoryTabState) {
    let { titleWidth, contentWidth, tabs } = state;
    tabs = this._formatStateTabByProps(nextProps);
    const { letterMap } = this._exactData(nextProps);
    // 判断新增排序orderedList列表字段是否存在
    let { flatData } = this._exactData(nextProps);
    const { orderedList, keysText } = nextProps;
    if (keysText == "shopSign" && orderedList !== null && orderedList !== undefined && orderedList.length) flatData = orderedList
    // 计算宽度
    const { cells, width } = nextProps;
    if (cells) {
      const avgWidth = 100 / cells;
      titleWidth = `${avgWidth}%`;
      contentWidth = `${100 / (cells - 1)}%`;
    } else if (width) {
      titleWidth = `${width}px`;
      contentWidth = `${width}px`;
    }
    return { ...state, titleWidth, contentWidth, tabs, letterMap, flatData };
  }

  componentWillRender() {
    // 提取选中的tag
    const tags = this.state.checkType === ECheckType.Category
      ? this.getTagsFromStateTabs()
      : this.getTagsFromStateLetterMap();
    this.state.tags = tags;
  }

  render() {
    return template({ props: this.props, state: this.state, styles });
  }

  componentAfterRender() {
    setTimeout(() => {
      this._renderExpandButton();
    })
  }

  renderInput() {
    this.$el.find('oy-input').each((_idx, element) => {
      const $element = $(element);
      $element.OYInput({
        value: this.props.shopSignLike || '',
        onChange: (value: string) => {
          this.state.inputValue = value;
        }
      })
    })
  }

  renderButton() {
    this.$el.find('oy-button').each((_ind, element) => {
      const $element = $(element);
      let onClick: any = () => { };
      if ($element.hasClass(styles.btn_toogle)) {
        onClick = this.handleToggleClick;
      } else if ($element.hasClass(styles.btn_more)) {
        onClick = this.handleExpandClick;
      } else if ($element.hasClass(styles.btn_up)) {
        onClick = this.handleUpClick;
      } else if ($element.hasClass(styles.btn_cancel)) {
        onClick = this.handleCancelClick;
      } else if ($element.hasClass(styles.btn_confirm)) {
        onClick = this.handleConfirmClick;
      } else if ($element.hasClass(styles.btn_letter)) {
        onClick = this.handleLetterClick;
      } else if ($element.hasClass(styles.btn_cate)) {
        onClick = this.handleCateClick;
      } else if ($element.hasClass(styles.confirm)) {
        onClick = this.handleSearchClick;
      }

      $element.OYButton({
        onClick: onClick.bind(this)
      })
    })
  }

  renderTab() {
    const { tabs, letterMap, checkType, curretTabKey, letterTabKey, flatData } = this.state
    if (!flatData.length) {
      return;
    }
    if (checkType === ECheckType.Category) {
      this.oyTab = this.$el.find('oy-tab').OYTab({
        value: curretTabKey,
        tabs,
        onTabChange: (data: IOYTab) => {
          this.state.curretTabKey = data.key;
        }
      })
    } else {
      this.oyTab = this.$el.find('oy-tab').OYTab({
        value: letterTabKey,
        tabs: letterMap,
        onTabChange: (data: IOYTab) => {
          this.state.letterTabKey = data.key;
        }
      })
    }
  }

  renderCheckbox() {
    const { maxTextLength, cells, width } = this.props;
    const { checkboxOption, checkType, tabs, letterMap } = this.state;

    const option = {
      ...checkboxOption,
      cells,
      width,
      maxTextLength,
      splitIndeterminate: true,
      collapse: 2
    }
    if (checkType === ECheckType.Category) {
      this.$el.find('oy-checkbox2').each((_idx, element) => {
        const $element = $(element)
        const [pindex, cindex] = $element.data('index').split(',');
        const { info } = tabs[pindex].info[cindex];
        const value = info.filter((va: any) => va.checked).map((val: any) => val.value);
        $element.OYCheckbox2({
          ...option,
          value,
          info,

          onChange: (cvalue: string[], isCancel: boolean) => {
            this.state.tabs[pindex].info[cindex].info = info.map((va: any) => {
              return { ...va, checked: valueIncludes(cvalue, va.value) }
            })

            if (!this.state.check && !isCancel) {
              this._emitChangeAndSearch(cvalue)
            } else {
              const tags = this.getTagsFromStateTabs();
              if (isCancel) {
                this._emitChangeAndSearch(tags.map(tag => tag.value))
              } else {
                this._setState({ tags });
                this.renderCheckedTags();
              }
            }
          }
        })
      })
    } else {
      this.$el.find('oy-checkbox2').each((_idx, element) => {
        const $element = $(element)
        const index = $element.data('index');
        const { info } = letterMap[index];
        const value = info.filter((va: any) => va.checked).map((val: any) => val.value);
        $element.OYCheckbox2({
          ...option,
          value,
          info,
          onChange: (cvalue: string[], isCancel: boolean) => {
            this.state.letterMap[index].info = info.map((va: any) => {
              return { ...va, checked: valueIncludes(cvalue, va.value) }
            })
            if (!this.state.check && !isCancel) {
              this._emitChangeAndSearch(cvalue)
            } else {
              const tags = this.getTagsFromStateLetterMap()
              if (isCancel) {
                this._emitChangeAndSearch(tags.map(tag => tag.value))
              } else {
                this._setState({ tags });
                this.renderCheckedTags();
              }
            }
          }
        })
      })
    }
  }

  renderCheckedTags() {
    this.$class(styles.tagContent).empty().append(selectedTagTemplate({ state: this.state, styles }));
    this.$el.find('oy-tag').each((_idx, element) => {
      const $element = $(element);
      $element.OYTag({
        allRemoveable: true,
        onRemove: (value: string) => {
          // 找到对应的节点.点击一下就行
          const item = this.oyTab!.$el.find(`.oy-checkbox-item[data-value="${value}"]`);
          item.trigger('click');
        }
      })
    })
  }

  /**
   * 渲染展开收起按钮
   */
  _renderExpandButton() {
    const { expand } = this.state;
    if (!expand) {
      const df = this.$node.flatData.get(0);
      if (!df) {
        return
      };

      // 取自己或者儿子中较大的一个高度.因为子级可能有外边距
      const itemHeight = this.$node.flatData.find(`.${styles.flatData_item}`).outerHeight(true);
      const height = Math.max(itemHeight, df.offsetHeight)
      if (df.scrollHeight <= height) {
        return
      }
    }

    const buttonProps: Partial<IOYButtonProps> = expand ?
      { text: '收起', icon: 'up', attrs: { class: `btn ${styles.operationBtn} ${styles.btn_up}` } } :
      { text: '更多', icon: 'down', attrs: { class: `btn ${styles.operationBtn} ${styles.btn_more}` } }

    const expandButton: OYButton = this.$class('expandButton').OYButton({ type: 'ghost', size: 'small', ...buttonProps });
    expandButton.addEvent({
      onClick: () => {
        if (expandButton.props.text === '更多') {
          this.handleExpandClick();
        } else {
          this.handleUpClick();
        }
      }
    })
  }

  setNode(): void {
    this.$node = {
      flatData: this.$el.find(`.${styles.flatData}`)
      // checkTabPaneContent: this.$el.find(`.${styles.checkTabPane_content}`)
    }
  }

  // 初始列表点击事件
  protected bindFlatDataItemClick() {
    this.$node.flatData.delegate(`.${styles.flatData_item}`, 'click', (ev: Event) => {
      const $element = $(ev.currentTarget!);
      const value = `${$element.data('value')}`;
      if ($element.hasClass(styles.checked)) {
        const values = this.state.tags.map(va => `${va.value}`).filter(va => va !== value)
        $element.removeClass(styles.checked);
        this._emitChangeAndSearch(values)
      } else {
        this.$node.flatData.children().removeClass(styles.checked)
        $element.addClass(styles.checked);
        this._emitChangeAndSearch([value])
      }
    })
  }

  // 选项分组点击
  // protected bindCheckTitleClick() {
  //   this.$el.find(`.${styles.checkTabPane_titlze} .${styles.checkTabPane_item}`).change((ev: Event) => {
  //     const $element = $(ev.currentTarget!);
  //     const checkedClass = styles.checkTabPane_itemChecked;

  //     // 多选
  //     if (this.$el.hasClass(styles.check)) {
  //       $element.toggleClass(checkedClass)
  //     } else {
  //       // 单选
  //       if ($element.hasClass(checkedClass)) {
  //         return;
  //       }
  //       this.$node.checkTabPaneContent
  //         .children().removeClass(checkedClass)
  //         .find('input').prop({ checked: false });
  //       $element.addClass(checkedClass);
  //       $element.find('input').prop({ checked: true })

  //       this.eventEmitter.emit(EEventType.onChange, [$element.data('value')])
  //       this.eventEmitter.emit(EEventType.onSearch)
  //     }
  //   })
  // }

  // tab框内item点击
  // protected bindCheckTabPaneItemClick() {
  //   const handleClick = (ev: Event) => {
  //     const $element = $(ev.currentTarget!);
  //     const checkedClass = styles.checkTabPane_itemChecked;
  //     // 多选
  //     if (this.$el.hasClass(styles.check)) {
  //       $element.toggleClass(checkedClass)
  //     } else {
  //       // 单选
  //       if ($element.hasClass(checkedClass)) {
  //         return;
  //       }
  //       this.$node.checkTabPaneContent
  //         .children().removeClass(checkedClass)
  //         .find('input').prop({ checked: false });
  //       $element.addClass(checkedClass);
  //       $element.find('input').prop({ checked: true })

  //       this.eventEmitter.emit(EEventType.onChange, [$element.data('value')])
  //       this.eventEmitter.emit(EEventType.onSearch)
  //     }
  //   }
  //   this.$node.checkTabPaneContent.find(`.${styles.checkTabPane_item}`).change(handleClick)
  // }

  // 重置样式
  protected resetRadioWithCheckboxClass() {
    return this.$el.removeClass(styles.expand + ' ' + styles.check);
  }

  // 点击展开
  private handleExpandClick() {
    this.setState({ expand: true, check: false })
  }

  // 点击收起
  private handleUpClick() {
    this.setState({ expand: false, check: false })
  }

  private handleToggleClick() {
    this.setState({
      expand: false,
      check: true,
      checkboxOption: {
        box: true,
        mode: ECheckMode.Checkbox
      }
    })
  }

  private handleCancelClick() {
    const tabs = this._formatStateTabByProps(this.props); // 重置tab
    this.setState({
      tabs,
      expand: false,
      check: false,
      checkboxOption: {
        box: false,
        mode: ECheckMode.Radio
      }
    })
  }

  private handleConfirmClick() {
    const value = this.state.tags.map(va => va.value);
    this._emitChangeAndSearch(value);
  }

  // 点击按字母分类
  private handleLetterClick() {
    this.setState({
      checkType: ECheckType.Letter
    })
  }

  private handleCateClick() {
    this.setState({ checkType: ECheckType.Category })
  }

  private handleSearchClick() {
    this.$emit('onInputChange', this.state.inputValue)
    // this._emitChangeAndSearch([this.state.inputValue])
  }

  private _formatStateTabByProps({ info, value }: IOYCategoryTabProps) {
    const tabs = info.map(item => {
      const iinfo = item.info.map(va => {
        const vinfo = [{ name: va.name, value: va.value, indeterminate: true }].concat(va.info as any).map((cva: any) => {
          return {
            checked: valueIncludes(value, `${cva.value}`),
            ...cva
          }
        })
        return { ...va, info: vinfo };
      })
      return { key: item.name, name: item.name, info: iinfo }
    });
    return tabs;
  }

  private _exactData(props: IOYCategoryTabProps) {
    const flatData = props.info.reduce((pre, cur) => {
      const infos = cur.info.reduce((ipre, icur) => ipre.concat(icur.info), [] as any[])
      return pre.concat(infos);
    }, [] as IOYCategoryTabInfoInfo[]);

    if (props.flatSort) {
      flatData.sort(props.flatSort)
    }

    let flatDataBack = JSON.parse(JSON.stringify(flatData)) as IOYCategoryTabInfoInfo[];

    const letterMap = letters.reduce((pre, cur) => {
      const reg = new RegExp(`^${cur}`, 'i');

      const [mm, fl] = flatDataBack.reduce((data, item) => {
        const isMatch = reg.test(item.letter);
        if (isMatch) {
          data[0][item.value] = item;
        } else {
          data[1].push(item);
        }
        return data;
      }, [{}, []] as any[]) // eslint版本有问题.不支持这种类型定义 [{ [i: string]: IOYCategoryTabInfoInfo }, IOYCategoryTabInfoInfo[]]

      flatDataBack = fl;

      const fdata = Object.keys(mm).map(key => mm[key]).map(va => {
        return { ...va, checked: valueIncludes(props.value, `${va.value}`) }
      });
      if (fdata.length) {
        pre.push({
          name: cur,
          key: cur,
          info: fdata
        })
      }
      return pre;
    }, [] as ILetterMap[])

    if (flatDataBack.length) {
      const fdb = flatDataBack
        .reduce((obj, item) => {
          obj[item.value] = item;
          return obj;
        }, {} as { [i: string]: IOYCategoryTabInfoInfo });

      letterMap.push({
        name: '#',
        key: '#',
        info: Object.keys(fdb).map(key => fdb[key])
      })
    }
    return {
      flatData,
      letterMap
    }
  }

  private _emitChangeAndSearch(value: string[]) {
    this.eventEmitter.emit(EEventType.onChange, value.map(va => `${va}`))
    this.eventEmitter.emit(EEventType.onSearch)
  }

  private getTagsFromStateTabs(tabs: IOYCategoryTabState['tabs'] = this.state.tabs) {
    return tabs.reduce((pre, cur) => {
      const data = cur.info.reduce((ipre, icur) => {
        return ipre.concat(icur.info.filter((va: any) => va.checked))
      }, [] as any)
      return pre.concat(data)
    }, [] as any[])
  }

  private getTagsFromStateLetterMap(letterMap: ILetterMap[] = this.state.letterMap) {
    return letterMap.reduce((pre, cur) => {
      return pre.concat(cur.info.filter((va: any) => va.checked))
    }, [] as any[])
  }
}



// WEBPACK FOOTER //
// ./src/components/OYCategoryTab/index.ts